// extracted by mini-css-extract-plugin
export default {"wrapper":"AddNewParticipant_wrapper__SilSk","form":"AddNewParticipant_form__PFCVy"};